import { useRequest } from '@mgm/common/lib';
import { TAxiosError } from '@mgm/common/types';
import { CONTROLLERS } from '../../utils/enums';
import { TSetAttributeReq } from '../../types/requests';
import { BASE_URL } from '../../../config';
import { getIdToken } from '../../utils/helpers';

export function PosOrdersController() {
  const {
    axiosRequest,
    initRequestOptions,
  } = useRequest(BASE_URL);

  const controllerName = CONTROLLERS.POS.ORDERS;
  const getStaff = <T>(data: { shopName: string, locationIds: Array<string | number> }): Promise<T |
  { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/get_staff`, options);
  };

  const setAttribute = <T>(data: TSetAttributeReq): Promise<T | { success: boolean; error: TAxiosError }> => {
    const options = initRequestOptions(data, { method: 'POST', authToken: getIdToken() });

    return axiosRequest(`${controllerName}/attribute`, options);
  };

  return {
    getStaff,
    setAttribute,
  };
}
